import * as types from "../../common/state/actionTypes";

export const updateDeviceTelemetryChartData = (deviceData) => {
  return { type: types.DEVICE_TELEMETRY_DATA_UPDATE, deviceData };
};

export const resetLiveDeviceTelemetryChart = () => {
  return { type: types.RESET_LIVE_DEVICE_TELEMETRY_DATA };
};
